import { BrowserRouter, Routes, Route } from "react-router-dom";
import SitePage from "./pages/SitePage";
import AdminDashboard from "./pages/AdminDashboard";
import { PaymentSuccess, PaymentCancel, PayPilot } from "./pages/PaymentResult";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<SitePage />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/pay" element={<PayPilot />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="*" element={<SitePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
